<div class="block-container">
  <h1 class="section-title fw-semibold">{{ field.props?.label }}</h1>
  <ng-container *ngFor="let field of field.fieldGroup">
    <formly-field [field]="field"></formly-field>
  </ng-container>
</div>
